package szlot

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@Serializable
data class GreeterProps(val title: String)

@Serializable
data class GreeterModel(val greeting: String)

/**
 * Shared RMI contract. The Visage KSP processor turns this into:
 *  - `AGreeterControllerBe` on the JVM target (backend base class)
 *  - `AGreeterControllerFe` + `GreeterControllerBeProxy` on the JS target
 *
 * The concrete classes (`GreeterControllerBe`, `MGreeterScene`,
 * `GreeterSceneState`, `GreeterControllerFe`) are hand-written — see the
 * jvmMain / jsMain sources.
 */
@VisageController(props = GreeterProps::class, model = GreeterModel::class)
interface IGreeter {
    fun greet(name: String)
}
